<script setup>
  import { RouterView } from 'vue-router'
  import Menu from "../components/mainNav.vue";
  import Feet from "../components/static/feet.vue";
  import FloatingButton from "../components/static/floating-button.vue";
</script>

<template>
  <Menu />
   <main class="page-wrapper" style="margin-bottom: 5rem !important;">
     <RouterView />
   </main>
  <Feet />
  <FloatingButton />
</template>

<style scoped>

</style>
